import angular from 'angular';
import KEYCODES from '../keycodes/keycodes';
import shortcutClick from './shortcutClick';
import shortcutFocus from './shortcutFocus';

export default angular
  .module('csm.util.shortcuts', [KEYCODES])
  .constant('SHORTCUT_CONSTANTS', {
    IS_MAC: navigator.userAgent.toLowerCase().includes('mac'),
    ATTR_DISABLED: 'shortcut-disabled',
    ATTR_CLICK: 'shortcut-click',
    ATTR_FOCUS: 'shortcut-focus',
    ATTR_HIDE_LABEL: 'shortcut-hide-label',
    MODIFIER_ALT: { name: 'Alt', attr: 'shortcut-alt' },
    MODIFIER_CTRL: { name: 'Ctrl', attr: 'shortcut-ctrl' },
    MODIFIER_OPT: { name: 'Option', attr: 'shortcut-alt' },
    MODIFIER_SHIFT: { name: 'Shift', attr: 'shortcut-shift' }
  })
  .directive('shortcutClick', shortcutClick)
  .directive('shortcutFocus', shortcutFocus).name;
